import { COUNTRY_CODE } from '../constants';

const currentCountry = process.env.NEXT_PUBLIC_COUNTRY_CODE || COUNTRY_CODE.COLOMBIA;

const currencies = {
  [COUNTRY_CODE.COLOMBIA]: 'COP',
  [COUNTRY_CODE.MEXICO]: 'MXN',
};
const locales = {
  [COUNTRY_CODE.COLOMBIA]: 'es-CO',
  [COUNTRY_CODE.MEXICO]: 'es-MX',
};

const currentCurrency = currencies[currentCountry];
const currentLocale = locales[currentCountry];

export function formatMoney(amount: number, _precision = 0): string {
  const formatter = new Intl.NumberFormat(currentLocale, {
    style: 'currency',
    currency: currentCurrency,
    minimumFractionDigits: 2,
  });

  const fraction = new Intl.NumberFormat(currentLocale, {
    style: 'currency',
    currency: currentCurrency,
    minimumFractionDigits: 0,
  });

  if (amount % 1 === 0) {
    return fraction.format(amount);
  }
  return formatter.format(amount);
}
